import { useEffect, useState } from 'react';
import { cloutReviewsApi } from '../services/cloutReviews';

// Whether reviews on CLOUT are open (CLOUT_REVIEWS_ENABLED on the backend). False until the
// answer arrives, and if the request fails, so review sections never flash up while closed.
export const useCloutReviewsEnabled = (): boolean => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    let cancelled = false;
    cloutReviewsApi
      .getStatus()
      .then((status) => !cancelled && setEnabled(status.enabled))
      .catch(() => {
        // Treat as closed
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return enabled;
};
